import { FC } from "react";
import { Paragraph } from "capitalrx-components-2.0";

import { faqData } from "./frequentlyAskedQuestions";
import FAQDesktop from "./Desktop/FAQDesktop";
import FAQMobile from "./Mobile/FAQMobile";
import styles from "./FAQSection.module.scss";

const FAQSection: FC = () => {
  return (
    <section className={styles.FAQSectionWrapper} data-testid="faq-section">
      <Paragraph className={styles.FAQSectionTitle}>Frequently Asked Questions:</Paragraph>
      <FAQDesktop faqData={faqData} />
      <FAQMobile faqData={faqData} />
    </section>
  );
};

export default FAQSection;
